import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { Option } from 'types/Generics';
import { WaitlistPickerField } from './WaitlistPickerField';
import classes from './WaitlistPickerField.module.scss';

interface WaitlistTimeFieldProps {
    label: string;
    value: string | null;
    options: Array<Option<string>>;
    onChange: (value: string) => void;
}

export const WaitlistTimeField: React.FC<WaitlistTimeFieldProps> = ({
    label,
    value,
    options,
    onChange
}) => {
    const triggerRef = React.useRef<HTMLButtonElement>(null);
    const [isOpen, setIsOpen] = React.useState(false);

    const selectedOption = options.find(option => option.id === value);

    return (
        <>
            <WaitlistPickerField
                ref={triggerRef}
                label={label}
                open={isOpen}
                value={selectedOption?.name}
                placeholder={options.length > 0 ? 'Select hour' : 'Closed'}
                onClick={() => setIsOpen(options.length > 0)}
            />

            <Menu
                open={isOpen}
                anchorEl={triggerRef.current}
                classes={{ paper: classes.menu }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                onClose={() => setIsOpen(false)}
            >
                {options.map(option => (
                    <MenuItem
                        key={option.id}
                        className={classes.option}
                        selected={option.id === value}
                        onClick={() => {
                            onChange(option.id);
                            setIsOpen(false);
                        }}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
